<template>

  <div class="padded">
      <div class="dash-heading"><i class="fa fa-chart-line" />&nbsp;Roll-Out Report</div>
      <br />
      <el-form inline>
         <select-year label="Year" v-model="thisYear" />
      </el-form>

      <sites-report :selected-year="thisYear" />
      <br />
      <sites-report :selected-year="lastYear" />
      <br />
      <sites-report :selected-year="prioYear" />
  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import SitesReport from '@/components/dashboard/sites/SitesReport'

export default {
  mixins: [DateMixins],

  components: {
    SitesReport
  },

  computed: {

    lastYear: function () {
      return this.thisYear - 1
    },

    prioYear: function () {
      return this.thisYear - 2
    }

  },

  watch: {
    thisYear: function (value) {
      this.thisYear = Number(value)
      this.$forceUpdate()
    }
  },

  data () {
    return {
      thisYear: this.year()
    }
  }
}

</script>
